import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { 
//navigate,
COMPLAINTS_STORE_SEARCH, } from "../redux/actions";
export const useNavigate = (locationToStore) => {
    const dispatch = useDispatch();
    let history = useHistory();
    return (path) => {
        if (locationToStore) {
            dispatch({ type: COMPLAINTS_STORE_SEARCH, payload: locationToStore });
        }
        history.push(path);
    };
};
